<template>
    <b-form
            class="service-provider-get-connected-form"
            @submit.prevent=""
    >
        <b-form-group
                v-if="fields.includes(FIELDS.FROM)"
                label="From"
                label-for="get-connected-from-input"
                label-class="get-connected-form-label"
                class="get-connected-form-group"
        >
            <b-form-input
                    v-model="internalModel.from"
                    id="get-connected-from-input"
                    required
            />
            <form-errors
                    v-if="errors.from"
                    :errors="errors"
                    field="from"
            />
        </b-form-group>

        <b-row>
            <b-col
                    v-if="fields.includes(FIELDS.EMAIL)"
                    :cols="12"
                    :md="6"
            >
                <b-form-group
                        label="Email"
                        label-for="get-connected-email-input"
                        label-class="get-connected-form-label"
                        class="get-connected-form-group"
                >
                    <b-form-input
                            v-model="internalModel.email"
                            id="get-connected-email-input"
                            required
                    />
                    <form-errors
                            v-if="errors.email"
                            :errors="errors"
                            field="email"
                    />
                </b-form-group>
            </b-col>

            <b-col
                    v-if="fields.includes(FIELDS.PHONE)"
                    :cols="12"
                    :md="6"
            >
                <b-form-group
                        label="Phone"
                        label-for="get-connected-phone-input"
                        label-class="get-connected-form-label"
                        class="get-connected-form-group"
                >
                    <b-form-input
                            v-model="internalModel.phone"
                            id="get-connected-phone-input"
                            required
                    />
                    <form-errors
                            v-if="errors.phone"
                            :errors="errors"
                            field="phone"
                    />
                </b-form-group>
            </b-col>
        </b-row>

        <div
                v-if="fields.includes(FIELDS.RESPOND_BY)"
                class="get-connected-contact-method-group"
        >
            <div class="get-connected-form-group d-flex text-left mb-0">
                <div class="get-connected-form-label checkbox-group-label">
                    Respond to me by
                </div>
                <b-form-checkbox
                        v-model="internalModel.respondByEmail"
                        class="get-connected-form-checkbox"
                >
                    Email
                </b-form-checkbox>
                <b-form-checkbox
                        v-model="internalModel.respondByPhone"
                        class="get-connected-form-checkbox"
                >
                    Phone
                </b-form-checkbox>
            </div>
            <form-errors
                    v-if="errors.respondBy"
                    :errors="errors"
                    field="respondBy"
            />
        </div>

        <b-form-group
                v-if="fields.includes(FIELDS.MESSAGE)"
                label="Message"
                label-for="get-connected-message-textarea"
                label-class="get-connected-form-label"
                class="get-connected-form-group"
        >
            <b-form-textarea
                    v-model="internalModel.message"
                    id="get-connected-message-textarea"
                    class="description-textarea"
                    rows="3"
                    no-resize
            />
            <form-errors
                    v-if="errors.message"
                    :errors="errors"
                    field="message"
            />
        </b-form-group>
        <b-form-group
                v-if="fields.includes(FIELDS.ATTACHMENTS)"
                label="Attachments - optional"
                label-for="get-connected-files-input"
                label-class="get-connected-form-label"
                class="get-connected-form-group"
        >
            <file-resource-drag-and-drop
                    id="get-connected-files-input"
                    v-model="internalModel.attachments"
                    @input="handleFileInput"
                    layout="stacked"
                    :max-files="5"
                    ref="formFiles"
            />
        </b-form-group>
        <b-form-group
                v-if="fields.includes(FIELDS.POLICY)"
        >
            <file-manage
                    v-model="internalModel.policyUuid"
                    add-text="+ Add Policy"
                    :tooltip-message="tooltipMessage"
                    :show-add-button="false"
            />
</b-form-group>
    </b-form>
</template>

<script>
    import './GetConnectedForm.scss';
    import FormErrors from '../../../../../components/FormErrors/FormErrors.vue';
    import VModel from "../../../../../mixins/VModel";
    import AppResourceCollection from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceCollection";
    import FileResourceDragAndDrop from '../../../../DragAndDropResource/FileResourceUploader/FileResourceDragAndDrop.vue';
    import FileManage from "../../../../File/FileManage/FileManage.vue";

    export const FROM = 'FROM';
    export const EMAIL = 'EMAIL';
    export const PHONE = 'PHONE';
    export const RESPOND_BY = 'RESPOND_BY';
    export const MESSAGE = 'MESSAGE';
    export const ATTACHMENTS = 'ATTACHMENTS';
    export const POLICY = 'POLICY';

    export const FIELDS = {
        FROM,
        EMAIL,
        PHONE,
        RESPOND_BY,
        MESSAGE,
        ATTACHMENTS,
        POLICY,
    };


    export default {
        name: "GetConnectedForm",
        components: {
            FormErrors,
            FileResourceDragAndDrop,
            FileManage,
        },

        mixins: [
            VModel,
        ],

        props: {
            value: {
                type: Object,
                required: true,
            },

            errors: {
                type: Object,
                default: () => {
                }
            },

            fields: {
                type: Array,
                default: () => {
                    return [];
                }
            }
        },

        data() {
            return {
                FIELDS,
                showTooltip: true,
                tooltipMessage: ''
            };
        },

        methods: {
            handleFileInput(value) {
                this.$emit('input', this.internalModel);
            }
        },
        mounted() {
            this.tooltipMessage = this.internalModel.policyUuid ?
                'We\'ve attached your policy for you!' :
                '';
            this.unwatchIsLiveProp = this.$watch('internalModel.policyUuid', (newVal) => {
                this.unwatchIsLiveProp();
                this.tooltipMessage = '';
            });
        },
    };
</script>
